const flashes = document.querySelectorAll('.flash');

for (const flash of flashes) {
	const btn = flash.querySelector('button');
	if (!btn) {
		continue;
	}
	btn.addEventListener('click', () => {
		flash.remove();
	});
}


(function(a,c,b){var d=false;c.recaptcha=function(e){if(a.getElementsByClassName("g-recaptcha").length>0){e.ready(function(){e.execute()});d=true}};if(!d){c.recaptcha(b)}})(document,Nette,grecaptcha);
